import { render, staticRenderFns } from "./DemandDetail.vue?vue&type=template&id=48c075b1&scoped=true"
import script from "./DemandDetail.vue?vue&type=script&lang=js"
export * from "./DemandDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c075b1",
  null
  
)

export default component.exports